import { DecimalPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { IonButton, IonIcon, IonSpinner } from '@ionic/angular/standalone'
import { TranslatePipe } from '@ngx-translate/core'

import { AhLadderPnlComponent } from '../../../../shared/components/asian-handicap-pnl/ah-ladder-pnl/ah-ladder-pnl.component'
import { FormErrorMessageComponent } from '../../../../shared/components/form-error-message/form-error-message.component'
import { SelectedRunner } from '../../../../shared/components/place-bet-modal/types/selected-runner.type'
import { FeatureFlagDirective } from '../../../../shared/directives/feature-flag.directive'

type PlaceBetForm = FormGroup<{
	odd: FormControl<number | null>
	stake: FormControl<number | null>
}>

@Component({
	selector: 'app-v3-place-bet-view',
	templateUrl: './v3-place-bet-view.component.html',
	styleUrls: ['./v3-place-bet-view.component.scss'],
	standalone: true,
	imports: [
		AhLadderPnlComponent,
		DecimalPipe,
		FeatureFlagDirective,
		FormErrorMessageComponent,
		IonButton,
		IonIcon,
		IonSpinner,
		ReactiveFormsModule,
		TranslatePipe,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V3PlaceBetViewComponent {
	placeBetForm = input.required<PlaceBetForm>()

	selectedRunner = input.required<SelectedRunner>()

	sideLabel = input.required<string>()

	errorMessage = input<string | null>(null)

	isHandicapTypeMarket = input<boolean>(false)

	isOddReadonly = input<boolean>(false)

	isPlacing = input<boolean>(false)

	isPlaceBetDisabled = input<boolean>(false)

	quickBetAmounts = input<string[]>([])

	showMinMaxStakeButtons = input<boolean>(false)

	minStake = input<number | null>(null)

	maxStake = input<number | null>(null)

	keypadKeys = input<string[]>([])

	totalExposureDebugging = input<number | null | undefined>(null)

	dismiss = output<void>()

	decrementOdd = output<void>()

	incrementOdd = output<void>()

	decrementStake = output<void>()

	incrementStake = output<void>()

	setStake = output<string>()

	setLimitStake = output<number>()

	applyKeypadValue = output<string>()

	showDebugging = output<void>()

	get titleSideLabel() {
		return this.sideLabel() === 'BACK' ? 'Back (Bet For)' : this.sideLabel()
	}

	get shouldShowErrors() {
		const form = this.placeBetForm()
		return Boolean(
			form.controls.odd.errors || ((form.controls.stake.dirty || form.controls.stake.touched) && form.controls.stake.errors) || this.errorMessage(),
		)
	}

	get visibleQuickBetAmounts() {
		return this.quickBetAmounts().slice(0, 4)
	}
}
